import featureFlagsJson from "../../feature_flags.json";

const VERSION = import.meta.env.VITE_LANG_VERSION;

export default {
  ...featureFlagsJson[VERSION],
  VERSION,
  CONTACT_MAIL:
    VERSION === "it"
      ? "tassadisoggiorno-airbnb@pec.it"
      : "contact@taxedesejour-airbnb.fr",
};
